"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;z-index:1;box-sizing:border-box;padding:16px 48px 12px 13px;fill:", color.grey1, "\n\n  button{", _styleConsts.buttonReset, "\n    position:absolute;top:16px;right:16px;width:18px;height:18px;justify-content:center;outline:none;}")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("header", {
  target: "css-bgn2ol0"
})(styles));

exports.default = _default;